import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton, Tooltip } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import type { Playbook } from "../../types/playbooks.types";

type PlaybooksTableActionsCellProps = {
    playbook: Playbook;
    onEdit: (playbook: Playbook) => void;
    onDelete: (playbook: Playbook) => void;
};

export const PlaybooksTableActionsCell = ({ playbook, onEdit, onDelete }: PlaybooksTableActionsCellProps) => {
    const { translate } = useTranslate();

    return (
        <Flex
            alignItems="center"
            gap="4px"
            margin="0 4px"
            justifyContent="space-between"
        >
            <Box flex="1">
                <Tooltip content={translate("si.common.edit")}>
                    <IconButton
                        type="flat"
                        iconName="edit-icon-fill"
                        iconSize="xs"
                        onClick={() => onEdit(playbook)}
                        dataAutomation="playbooks-edit"
                    />
                </Tooltip>
            </Box>
            <Box flex="1">
                <Tooltip content={translate("si.common.button.delete")}>
                    <IconButton
                        type="flat"
                        iconName="delete"
                        iconSize="xs"
                        onClick={() => onDelete(playbook)}
                        dataAutomation="playbooks-delete"
                    />
                </Tooltip>
            </Box>
        </Flex>
    );
};
